import { useLanguage } from '@/hooks/Contexts'

export default function NoDataLayout(props: { extraCls?: string }) {
  const { errors } = useLanguage()
  return <div className={`w-full justify-center py-4 text-center ${props.extraCls || ''}`}>{errors.no_data}</div>
}
